import React, { useEffect, useRef, useState } from 'react';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';

import LoadingSpinner from '../common/LoadingSpinner';
import { ADYEN_CLIENT_ID, ADYEN_ENVIRONMENT } from '../../ConfigVars';

const AdyenDropIn = ({
  paymentMethods, onSubmit, amount, paymentSession,
}) => {
  const adyenContainer = useRef(null);
  const [checkout, setCheckout] = useState(null);

  useEffect(() => {
    if (!paymentSession) return;
    const initializeCheckout = async () => {
      try {
        const checkoutInstance = await AdyenCheckout({
          clientKey: ADYEN_CLIENT_ID,
          environment: ADYEN_ENVIRONMENT,
          countryCode: 'de-DE',
          session: null,
          amount,
          locale: 'de-DE',
          paymentMethodsResponse: paymentMethods,
          paymentMethodsConfiguration: {
            card: {
              hasHolderName: true,
              holderNameRequired: true,
              billingAddressRequired: false,
              amount,
            },
          },
          onSubmit: (values) => {
            onSubmit(values);
          },
        });
        if (checkoutInstance.create) {
          const dropin = checkoutInstance
            .create('dropin')
            .mount(adyenContainer.current);
          setCheckout(dropin);
        } else {
          console.log(checkoutInstance);
        }
      } catch (error) {
        console.error('Adyen Checkout initialization failed:', error);
      }
    };

    initializeCheckout().then(() => console.log('initialized'));

    return () => {
      if (checkout) {
        checkout.unmount();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, onSubmit, paymentMethods, paymentSession]);

  return (
    <div>
      <div ref={adyenContainer} />
      {!checkout && (
      <div className="mt-3">
        <LoadingSpinner message="Loading additional payment methods" />
      </div>
      )}
    </div>
  );
};

export default AdyenDropIn;
